"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AuthenticationMode;

(function (AuthenticationMode) {
  AuthenticationMode["header"] = "header";
  AuthenticationMode["cookie"] = "cookie";
})(AuthenticationMode = exports.AuthenticationMode || (exports.AuthenticationMode = {}));